export const SET_FILTERED = "filtered/SET_FILTERED";
export const SET_FILTERED_ON_ROUTE_CHANGE =
	"filtered/SET_FILTERED_ON_ROUTE_CHANGE";
